<mat-card>
  <mat-card-title>
    <div fxLayout="row">
      <div fxFlex></div>
      <div>Validar Pedido</div>
      <div fxFlex></div>
    </div>
  </mat-card-title>
  <mat-card-content>
    <div fxLayout="row">
      <mat-form-field fxFlex>
        <input matInput placeholder="Número de pedido" aria-label="Número de pedido" [matAutocomplete]="auto" [formControl]="autocompleteCtrl">
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="itemSelected($event)">
          <mat-option *ngFor="let order of filteredOrders | async" [value]="order.id">
            <div fxLayout="row">
              <span fxFlex="15">
                <mat-icon color="primary">description</mat-icon> {{ order.id }}</span>
              <span fxFlex>{{ order.clientName }}</span>
              <span> {{ order.internalStatus }} </span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </mat-card-content>
</mat-card>
